'use client'

import type { GridCardSectionFragment } from '@/lib/types/datocms/graphql/generated'
import { TextWithHighlight } from '../TextWithHighlight'
import CtaDefault from '../ui/cta/CtaDefault'
import Eyebrow from '../ui/Eyebrow'
import { StructuredText } from 'react-datocms'

import DealershipCards from '../PaginatedGridCards'
import { isStructuredTextEmpty } from '@/utils/datocms/isStructuredTextEmpty'
import PaginatedGridCards from '../PaginatedGridCards'

export default function GridCardSection({
	title,
	tag,
	description,
	cta,
	items,
}: Readonly<GridCardSectionFragment>) {
	return (
		<section className="grid-card-section bg-white-frosted @container">
			<div className="max-w-screen-2xl mx-auto py-16 @5xl:py-24 common-x-padding">
				{tag ? <Eyebrow>{tag}</Eyebrow> : null}
				<div className="flex flex-col @5xl:flex-row justify-between gap-8 mt-10 pb-16 @5xl:pb-24">
					{title && !isStructuredTextEmpty(title.text) && (
						<div className="heading-size-2 ">
							<TextWithHighlight text={title} />
						</div>
					)}
					<div className="max-w-xl">
						{description && !isStructuredTextEmpty(description) && (
							<div className="text-lg @5xl:text-2xl text-blue-dark/70">
								<StructuredText data={description} />
							</div>
						)}
						{cta && (
							<CtaDefault cta={cta} className="mt-8 @5xl:mt-10">
								{cta.label}
							</CtaDefault>
						)}
					</div>
				</div>
				<PaginatedGridCards items={items} />
			</div>
		</section>
	)
}
